// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__38nA6","list":"PatternAutocomplete_list__npAJQ"};